import React, { useState, useEffect } from "react";
import {
  changeVoiceReadStatus,
  setChatPhone,
  setChatMessage,
  fetchSilentMessage,
  sendMessage,
  onChangeNotes,
  fetchVoicemails,
  setVoiceChatPhone,
  fetchVoiceChat,
  deleteVoiceChat,
  fetchVoicemailsLoading,
  triggerVoiceChatPush,
  UpdateNotesVoicemail,
} from "../../../redux/action";
import { useSelector, useDispatch } from "react-redux";
import CreateContactSlider from "../../../components/Contacts/CreateContactSlider";
import DeleteVoicemailModal from "../../../components/Voicemail/DeleteVoicemailModal";
import SendMessageModal from "../../../components/Voicemail/SendMessageModal";
import VoicemailsTable from "../../../components/Voicemail/VoicemailsTable";
import VoiceMails from "../../../components/Voicemail/VoiceMails";
import VoicemailContainerHeader from "../../../components/Voicemail/VoicemailContainerHeader";

function VoiceMail() {
  const dispatch = useDispatch();
  const voicemails = useSelector((state) => state.voicemails);
  const [activeVoicemail, setActiveVoicemail] = useState("");
  const [selectedChats, setSelectedChats] = useState([]);
  const [filter, setFilter] = useState("all");
  const [current, setCurrent] = useState("");
  const [isSelectEnable, setIsSelectEnable] = useState(false);

  const handleSendMessage = () => {
    dispatch(setChatPhone(voicemails.chat_phone_no));
    dispatch(sendMessage());
    dispatch(fetchSilentMessage());
  };

  const toggleCheckbox = (e, msg) => {
    if (e.target.checked) {
      setSelectedChats([...selectedChats, msg]);
    } else {
      var updated = selectedChats.filter((chat) => chat.id !== msg.id);
      setSelectedChats([...updated]);
    }
    console.log(selectedChats);
  };

  const handleDelete = () => {
    let currentPhone =
      voicemails.chat_data.length > 0 && voicemails.chat_data[0].sender_phone;
    let phone = voicemails.chat_phone_no;
    if (currentPhone) {
      dispatch(fetchVoicemailsLoading());
      dispatch(deleteVoiceChat(currentPhone));
      if (currentPhone == phone) {
        dispatch(setVoiceChatPhone(false));
      }
      dispatch(triggerVoiceChatPush());
    }
    getVoiceMails();
  };

  const bulkDelete = () => {
    for (let i = 0; i < selectedChats.length; i++) {
      let currentPhone = selectedChats[i].sender_phone;
      let phone = voicemails.chat_phone_no;
      if (currentPhone) {
        dispatch(fetchVoicemailsLoading());
        dispatch(deleteVoiceChat(currentPhone));
        if (currentPhone == phone) {
          dispatch(setVoiceChatPhone(false));
        }
        dispatch(triggerVoiceChatPush());
      }
    }
    getVoiceMails();
  };

  const getVoiceMails = () => {
    dispatch(fetchVoicemails());
  };
  const handleInitialReadStatus = (message) => {
    if (message && !message.read_status)
      dispatch(changeVoiceReadStatus(message.id));
  };

  useEffect(() => {
    getVoiceMails();
    if (voicemails && voicemails.data && voicemails.data.length > 0) {
      handleInitialReadStatus(voicemails.data[0]);
    }
  }, []);
  console.log(isSelectEnable);
  return (
    <>
      <div className="row mt-4">
        <div
          id="voicemail-list"
          className="col-md-4 col-lg-4 col-sm-12 col-xs-12 main-section-scroll-height">
          <div className="mt-2 d-flex justify-content-between align-items-center">
            <div className="">
              <button
                className={`${
                  filter === "all" ? "primary-btn" : "primary-btn-transparent"
                } me-1`}
                onClick={() => setFilter("all")}>
                {" "}
                All
              </button>
              <button
                className={`${
                  filter === "unread"
                    ? "primary-btn"
                    : "primary-btn-transparent"
                }`}
                onClick={() => setFilter("unread")}>
                Unread
              </button>
            </div>
            <div className="d-flex align-items-center">
              {!isSelectEnable ? (
                <button
                  className="primary-btn ms-2"
                  onClick={() => setIsSelectEnable(true)}>
                  Select
                </button>
              ) : (
                <div class="dropdown">
                  <button
                    className="primary-btn ms-2 dropdown-toggle"
                    data-bs-toggle="dropdown"
                    aria-expanded="false">
                    Action
                  </button>
                  <ul className="dropdown-menu dropdown-menu-end">
                    {selectedChats && selectedChats.length > 0 && (
                      <li onClick={selectedChats.length > 0 && bulkDelete}>
                        <a className="dropdown-item" href="#">
                          Delete
                        </a>
                      </li>
                    )}

                    <li onClick={() => setIsSelectEnable(!isSelectEnable)}>
                      <a className="dropdown-item" href="#">
                        Cancel
                      </a>
                    </li>
                  </ul>
                </div>
              )}
            </div>
          </div>
          <VoiceMails
            isSelectEnable={isSelectEnable}
            toggleCheckbox={toggleCheckbox}
            setActiveVoicemail={setActiveVoicemail}
            voicemails={voicemails}
            filter={filter}
            activeVoicemail={activeVoicemail}
          />
        </div>
        {!voicemails.isLoading ? (
          <div
            id="single-voicemail"
            className="col-md-8 col-lg-8 col-sm-12 col-xs-12 main-section-scroll-height background-white pt-2">
            <VoicemailContainerHeader voicemails={voicemails} />
            <VoicemailsTable voicemails={voicemails} />
          </div>
        ) : (
          <div className="loadingMessageContainer" />
        )}
      </div>
      <DeleteVoicemailModal handleDelete={handleDelete} />
      <SendMessageModal
        voicemails={voicemails}
        handleSendMessage={handleSendMessage}
      />
      <CreateContactSlider phone={voicemails.chat_phone_no} />
    </>
  );
}

export default VoiceMail;
